/* @flow */

import { saveAs } from 'file-saver'
import { roundNumber } from './number'

type ValidSizeType = 'GB' | 'MB' | 'KB' | 'B'

type SizeType = {
  size: number,
  suffix: ValidSizeType
}

type ContentType = {
  regex: RegExp,
  type: 'pdf' | 'image' | 'audio' | 'document'
}

export const SIZES: Array<SizeType> = [
  { size: 1024 * 1024 * 1024, suffix: 'GB' },
  { size: 1024 * 1024, suffix: 'MB' },
  { size: 1024, suffix: 'KB' },
  { size: 1, suffix: 'B' }
]

export const formatFileSize = (s?: string): string => {
  if (!s) return ''
  var size = parseFloat(s)
  for (let unit of SIZES) {
    if (unit.size < size) {
      const resultSize = roundNumber(size / unit.size, 1)
      return `${resultSize} ${unit.suffix}`
    }
  }
  return ''
}

export const CONTENT_TYPES: Array<ContentType> = [
  { regex: /^application\/pdf/, type: 'pdf' },
  { regex: /^image\//, type: 'image' },
  { regex: /^audio\//, type: 'audio' },
  { regex: /.*/, type: 'document' }
]

export const flattenContentType = (type?: string): string => {
  if (typeof type !== undefined) {
    var t = CONTENT_TYPES.find((entry) => {
      return entry.regex.test(type || '')
    })
  }
  return t ? t.type : ''
}

export const fileListToArray = (fileList: FileList): Array<File> => {
  let arr = []
  for (let i = 0; i < fileList.length; i++) {
    arr.push(fileList[i])
  }
  return arr
}

export const downloadFile = (name: string) => (blob: Blob) => {
  saveAs(blob, name)
}
